var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 7.5,
    stroke: "#482714"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 6H6.9C6.66131 6 6.43239 6.09482 6.2636 6.2636C6.09482 6.43239 6 6.66131 6 6.9V17.1C6 17.3387 6.09482 17.5676 6.2636 17.7364C6.43239 17.9052 6.66131 18 6.9 18H17.1C17.3387 18 17.5676 17.9052 17.7364 17.7364C17.9052 17.5676 18 17.3387 18 17.1V6.9C18 6.66131 17.9052 6.43239 17.7364 6.2636C17.5676 6.09482 17.3387 6 17.1 6Z",
    stroke: "#CD8F6C",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40039 10.5158C9.39789 9.31582 10.5979 8.71582 12.0004 8.71582C13.4029 8.71582 14.6029 9.31582 15.6004 10.5158",
    stroke: "#CD8F6C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 14.0998C12.2383 14.0998 12.4672 14.005 12.636 13.8362C12.8048 13.6674 12.8996 13.4385 12.8996 13.1998C12.8996 12.9611 12.8048 12.7322 12.636 12.5634C12.4672 12.3946 12.2383 12.2998 11.9996 12.2998C11.7609 12.2998 11.532 12.3946 11.3632 12.5634C11.1944 12.7322 11.0996 12.9611 11.0996 13.1998C11.0996 13.4385 11.1944 13.6674 11.3632 13.8362C11.532 14.005 11.7609 14.0998 11.9996 14.0998Z",
    fill: "#CD8F6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.0996L12.0024 13.1996",
    stroke: "#CD8F6C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightIcon);
export default __webpack_public_path__ + "static/media/weightIcon.69edc4eb4798fab5960920ee533b6775.svg";
export { ForwardRef as ReactComponent };